import { TriangleAlert } from "lucide-react";
import React from "react";

import { IgTooltip } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";

export const BillingWarningIcon = () => {
  const theme = useTheme();
  return (
    <IgTooltip title={"Store not installed"}>
      <TriangleAlert size={16} color={theme.igIconColors.warning} />
    </IgTooltip>
  );
};
